import { stringify } from 'query-string'
import {
  HTTP_METHOD_GET,
  apiRequest,
  commonRequestInstanceToAxiosRequestInfo,
} from '@/common/api/api.service'
import { API_BASE_URL } from '@/common/constant'
import { normalizeEventContentList } from '@/common/normalize'

/**
 * 이벤트 공지사항 게시판 글 상세 (특정 이벤트 포함 콘텐츠 목록[복합])
 * @param eventid 이벤트 고유 ID
 * @param contenttype 콘텐츠타입 (all / live / program / vod / movie / clip)
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 개수
 */
export const getEventContentList = async ({
  eventId,
  offset = 0,
  limit = 20,
}) => {
  const queryParams = stringify({
    offset,
    limit,
  })
  const response = await apiRequest(
    commonRequestInstanceToAxiosRequestInfo({
      url: `${API_BASE_URL}/events-contents/${eventId}?${queryParams}`,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true,
    }),
    (error) => {
      return { error: { ...error } }
    },
  )
  if (!response || response?.error) {
    return response
  }

  response.data = normalizeEventContentList(response?.data)
  return response
}
